import { string } from 'yup'
import { safify } from '../utils/safify'

export const additionalInfo = string()
  .default('')
  .meta({
    label: 'Additional info',
    mobilePlaceholder: 'Anything else not covered above',
    placeholder: 'Anything else not covered above',
    snippets: true,
    autoFill: true,
  })
  .transform(safify)
